import { Box, Typography } from '@mui/material'

import { getAddressed } from '../../hooks/useInspectionEntriesByStatus/useInspectionEntriesByStatus'
import { InspectionStatusWithEntries } from '../../models/inspections'
import { ClickableCard } from '../SharedUI/ClickableCard'
import { InspectionEntryStatusChip } from './InspectionEntryStatusChip'

export const InspectionResultSummaryChip = ({
  statusWithEntries,
  onClick,
  showAddressed
}: {
  statusWithEntries: InspectionStatusWithEntries
  onClick?: () => void
  showAddressed?: boolean
}) => {
  return (
    <ClickableCard onClick={onClick}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          p: 1,
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          boxSizing: 'border-box'
        }}>
        <Typography>
          {statusWithEntries.entries.length} {statusWithEntries.info!.title}
          {showAddressed
            ? ` (${getAddressed(statusWithEntries)} Addressed)`
            : ''}
        </Typography>
        <InspectionEntryStatusChip status={statusWithEntries} />
      </Box>
    </ClickableCard>
  )
}
